module.exports = __webpack_public_path__ + "static/img/chuzhongyuwen2.db0312a5.jpg";